import React from 'react';
import Icon from 'assets/Icon';
import styles from './style/alert.module.css';

const icon = (type:string) => {
  if (type === 'error' || type === 'error-overlay') {
    return (
      <Icon icon="Error" fill="strawberry" />
    );
  }
  if (type === 'warning') {
    return (
      <Icon icon="Warning" fill="fresh-yellow-700" />
    );
  }
  if (type === 'success' || type === 'success-overlay') {
    return (
      <Icon icon="Tick" fill="fresh-green" />
    );
  }
  return (
    <Icon icon="Info" fill="blueberry" />
  );
};

interface AlertProps {
  active: boolean,
  label: string,
  type: string,
}

const Alert = ({ active, label, type }:AlertProps) => (
  <div
    className={
      `${styles.box} subtitle1 ${active ? styles.box_active : ''}`
    }
    data-type={type}
  >
    <div className={styles.box__content}>
      <div className={styles.box__content__icon}>
        { icon(type) }
      </div>
      { label }
    </div>
  </div>
);

export default Alert;
